export default __webpack_public_path__ + "static/media/promission-login.1d709a86.png";